import styled from "styled-components";
import { NavLink as Link } from 'react-router-dom';
import {FaCode} from 'react-icons/fa';

export const Nav = styled.nav`
    background: #434343;
    height: 80px;
    display: flex;
    justify-content: center;
    font-weight: 700;
`;

export const NavLink = styled(Link)`
    color: #4AF626;
    font-size: 2rem;
    display: flex;
    align-items: center;
    text-decoration: none;
    /*cursor: pointer;*/
    @media screen and (max-width: 400px){
        position: absolute;
        top: 10px;
        left: 5px;
    }
`;

export const NavIcon =styled.div`
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    /*cursor: pointer;*/
    color: #4AF626;
    p{
        transform: translate(-175%, 60%);
        font-weight: bold;
    }
`;

export const Bars = styled(FaCode)`
    font-size: 2rem;
    transform: translate(-55%, -90%);
`;